import { TieredMenu } from "primereact/tieredmenu";
import React, { useRef } from "react";
import { CheveronDown, DateCalendarIcon } from "../../constant";
import classes from "./SelectorSkeleton.module.css";

const SelectorSkeleton = ({
  value,
  type = "",
  onChange,
  icon = <DateCalendarIcon />,
  options,
}) => {

  console.log(value, "saaata");
  const menu = useRef(null);
  return (
    <div>
      <div className={classes.wrapper}>
        <span>{icon}</span>
        <span className={classes.value}>{value}</span>
        <span
          onClick={(e) => menu.current.toggle(e)}
          className={classes.clickableBlock}
        >
          <CheveronDown className={classes.downIcon} />
        </span>
      </div>
      <TieredMenu
        className="calendar-tiered-menu"
        model={options}
        popup
        ref={menu}
        breakpoint="767px"
      />
    </div>
  );
};

export default SelectorSkeleton;
